module.exports = __webpack_public_path__ + "static/img/Xavier-Lindsay.49f0f4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Lindsay.jpg
// module id = GoyG
// module chunks = 0